import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import MI0103C from '../../components/MI/MI0103/index';
function mapDispatchToProps(_ref) {
  var mi0103Info = _ref.mi0103Info;
  return {
    mi0103Info: mi0103Info
  };
}
var MI0103R = _Form.create()(MI0103C);
export default connect(mapDispatchToProps)(MI0103R);